import React from 'react';
import {MasterLayout} from 'layout';
import {ChinhSuaCuocThanhTra} from 'modules/thanh-tra';

export default class ThemMoiCuocThanhTraPage extends React.Component {
 
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <ChinhSuaCuocThanhTra checkBS={this.props.location} type='DOT_XUAT'/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/thanh-tra/ThemMoiCuocThanhTraPage.jsx